import { ChangeDetectorRef, Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { StorageService } from '../../services/common/storage.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from '../../services/common/common.service';
import { ApiService } from '../../services/api.service';
import { ApiUrlHelper } from '../../services/api-url-helper/api-url-helper';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { PasswordMessageDialogueComponent } from '../password-message-dialogue/password-message-dialogue.component';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../../services/languageService/language-service.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrl: './reset-password.component.scss',
})
export class ResetPasswordComponent {
  resetPasswordForm: FormGroup;
  firstQuestion: string = '';
  secondQuestion: string = '';
  thirdQuestion: string = '';
  email:string ="";
  constructor(
    public dialog: MatDialog,
    private formBuilder: FormBuilder,
    private storageService: StorageService,
    private router: Router,
    private commonService: CommonService,
    private apiService: ApiService,
    private apiUrl: ApiUrlHelper,
    private toaster: ToastrService,
    private spinner: NgxSpinnerService,
    private cdRef: ChangeDetectorRef,
    private route: ActivatedRoute,
    private translate:TranslateService,
    private languageService: LanguageService,
  ) {
    this.languageService.language$.subscribe(language => {
      this.translate.use(language);
    });
    this.resetPasswordForm = this.formBuilder.group({
      firstQuestionAnswer: ['', [Validators.required]],
      secondQuestionAnswer: ['', [Validators.required]],
      thirdQuestionAnswer: ['', [Validators.required]],
    });
    this.getSignupQuestion();
  }
  getSignupQuestion() {

    history.pushState(null, '', location.href);
    window.addEventListener('popstate', () => {
      window.location.href = '/login'; // Forces reload and redirects
    });
    
    
    this.route.queryParams.subscribe(params => {
      if (params.hasOwnProperty('email')) {
        this.email = params['email'] || ''; 
        if (this.email) {
          let email = this.commonService.Decrypt(this.email);
          this.storageService.setValue('email', email);
        }
      }
    });
        
    const FormData = {
      Email: this.storageService.getValue('email').trim(),
    };
    this.spinner.show();
    const apiUrl = this.apiUrl.apiUrl.forgetPassword.getSignUpQuestion;
    this.apiService
      .doPost(apiUrl, FormData)
      .pipe()
      .subscribe({
        next: (response) => {
          this.spinner.hide();
          if (response && response.Success) {
            this.firstQuestion = response.Data.FirstQuestion;
            this.secondQuestion = response.Data.SecondQuestion;
            this.thirdQuestion = response.Data.ThirdQuestion;
          } else {
            this.toaster.error(this.translate.instant(response.Message));
          }
        },
        error: (er) => {
          this.spinner.hide();
          console.error(er);
          this.toaster.error(er.Message);
        },
      });
  }
  onSubmit() {
    Object.keys(this.resetPasswordForm.controls).forEach((key) => {
      const control = this.resetPasswordForm.get(key);
      if (control && typeof control.value === 'string') {
        control.setValue(control.value.trim(), { emitEvent: false });
      }
    });
    const FormData = {
      FirstQuestionAnswer: this.resetPasswordForm.value.firstQuestionAnswer,
      SecondQuestionAnswer: this.resetPasswordForm.value.secondQuestionAnswer,
      ThirdQuestionAnswer: this.resetPasswordForm.value.thirdQuestionAnswer,
      Email: this.storageService.getValue('email'),
    };
    this.spinner.show();
    const apiUrl = this.apiUrl.apiUrl.forgetPassword.validateQuestionAnswers;
    this.apiService
      .doPost(apiUrl, FormData)
      .pipe()
      .subscribe({
        next: (response) => {
          this.spinner.hide();
          if (response && response.Success) {
            let Email = this.commonService.Encrypt(response.Data.Email);
            let UserType = this.commonService.Encrypt(
              response.Data.UserType.toString()
            );
            this.router.navigate(['/set-new-password'], {
              queryParams: { email: Email, userType: UserType },
            });
          } else {
            //this.toaster.error(response.Message);
            const dialogRef = this.dialog.open(
              PasswordMessageDialogueComponent,
              {
                width: '500px',
                panelClass:'error-popup',
                data: {
                  // data will be based on API response
                  passwordError:true,
                  title: 'FIELD_MISMATCH_TITLE',
                  message:'FIELD_MISMATCH_DESC',
                },
              }
            );

            dialogRef.afterClosed().subscribe((result: any) => {
              if (result) {
              }
            });
          }
        },
        error: (er) => {
          this.spinner.hide();
          console.error(er);
          this.toaster.error(er.Message);
        },
      });
  }

  onSignup(){
    this.router.navigate(['/signup']);
  }
}
